import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

const systemDark = () => window.matchMedia("(prefers-color-scheme: dark)").matches;

export function ThemeProvider({ children }) {
  // theme is the user's choice: "light" | "dark" | "system"
  const [theme, setThemeState] = useState(() => localStorage.getItem("bf_theme") || "dark");

  useEffect(() => {
    localStorage.setItem("bf_theme", theme);
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const dark = theme === "system" ? mql.matches : theme === "dark";
      document.documentElement.classList.toggle("dark", dark);
    };
    apply();
    if (theme === "system") {
      mql.addEventListener("change", apply);
      return () => mql.removeEventListener("change", apply);
    }
  }, [theme]);

  const resolved = theme === "system" ? (systemDark() ? "dark" : "light") : theme;
  const setTheme = (t) => setThemeState(t);
  const toggle = () => setThemeState(resolved === "dark" ? "light" : "dark");

  return (
    <ThemeCtx.Provider value={{ theme, resolved, setTheme, toggle }}>
      {children}
    </ThemeCtx.Provider>
  );
}
